export { clearViewDesktopCookie } from './action';
export type { Action, ActionResponse } from './types';
